// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__9Aiji","bioCard":"About_bioCard__gZ+gv","pictureContainer":"About_pictureContainer__kFxg5","vibrate":"About_vibrate__gUDuj"};